import ApiService from "../ApiService";
export interface ExportErrorResponse {
    message: string;
    errors: string;
}

export type ExportExcelResponse = Blob | ExportErrorResponse;

const exportExcelData = async (codConcessionaria: number, type: string): Promise<ExportExcelResponse> => {
    const data = ApiService.getXlsx(`cardapio/export/${codConcessionaria}/${type}`);
    return data
};

const importExcelData = async (
    codConcessionaria: number,
    type: string,
    payload: any,
    onUploadProgress?: (progressEvent: ProgressEvent) => void // Callback para progresso
): Promise<{
    errors: string[],
    message: string
}> => {
    const { data } = await ApiService.post(
        `cardapio/import/${codConcessionaria}/${type}`,
        payload, 
        true,
        onUploadProgress // Passa a função de progresso
    );

    return data;
};
export interface EditIndex {
    horaMaoObra: string,
    familia: string,
    arteGrupo: string
}

const editImport = async (codConcessionaria: number): Promise<EditIndex[]> => {
    const { data } = await ApiService.get(`cardapio/import/edit/${codConcessionaria}`);
    return data;
}

export interface dataUpdateCardapio {
    horaMaoObra: string,
    arteGrupo:string,
    formatFamily: string,
    familia: string
}


const updateCardapio = async(payload: {codConcessionaria: number, data: dataUpdateCardapio[] | []}) : Promise<string> => {
    const { data } = await ApiService.post(`cardapio/import/update`, payload);   
    return data;
 }

export {
    exportExcelData,
    importExcelData,
    editImport,
    updateCardapio
}